import React from 'react';
import { KPI } from 'src/mtska-frontend-app-component';

const KPISet = ({ filters }) => {
    console.info('ridisegno');
    const date = new Date();
    const formattedDateToday = date.toISOString().split('T')[0];
    const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const formattedDateStartOfMonth = `${startOfMonth.getFullYear()}/${String(startOfMonth.getMonth() + 1).padStart(2, '0')}/${String(startOfMonth.getDate()).padStart(2, '0')}`;
    const currentMonthName = new Intl.DateTimeFormat('it-IT', { month: 'long' }).format(new Date());

    return (
        <>
            <KPI
                title="Leads"
                dataProviderName={'statisticsviews/item/count/opportunities/lead'}
                filters={{
                    items: [
                        ...(filters?.items || [])
                    ]
                }}
            />
            <KPI
                title={"Lead " + currentMonthName }
                dataProviderName={'statisticsviews/currentmonth/count/opportunities/lead'}
                filters={{
                    items: [
                        ...(filters?.items || []),
                        {
                            field: "registered_at",
                            operator: "afterOrEqual",
                            value: formattedDateStartOfMonth
                        }
                    ]
                }}
            />
            <KPI
                title={"Lead oggi"}
                dataProviderName={'statisticsviews/currentday/count/opportunities/lead'}
                filters={{
                    items: [
                        ...(filters?.items || []),
                        {
                            field: "registered_at",
                            operator: "afterOrEqual",
                            value: formattedDateToday
                        }
                    ]
                }}
            />
        </>
    )
}

export default KPISet;